import { useFormpage } from 'pages/forms/hooks/useFormpage';
import React, { createContext, PropsWithChildren, useContext } from 'react';
import { useAnswerManager } from 'pages/forms/hooks/useAnswerManager';
import { AnswerContext } from '../AnswerProvider';

export const FormspageContext = createContext({} as ReturnType<typeof useFormpage>);

export const FormsProvider = ({ children }: PropsWithChildren) => {
  const config = useFormpage();
  const answersConfig = useAnswerManager();
  return (
    <AnswerContext.Provider value={answersConfig}>
      <config.Snackbar />
      <FormspageContext.Provider value={config}>{children}</FormspageContext.Provider>
    </AnswerContext.Provider>
  );
};

export const useFormsContext = () => useContext(FormspageContext);
